import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_COMMITTEEMEMBER_LOAD,
    ACTION_COMMITTEEMEMBER_LOAD_BY_ID,
    ACTION_COMMITTEEMEMBER_LOAD_BY_COMMITTEE_ID,

    ACTION_COMMITTEEMEMBER_SAVE,

    ACTION_COMMITTEEMEMBER_CREATE,

    ACTION_COMMITTEEMEMBER_VALIDATE,

    ICommitteeMemberLoadAction,
    ICommitteeMemberLoadByIdAction,
    ICommitteeMemberLoadByCommitteeIdAction,
    ICommitteeMemberLoadFailureAction,
    ICommitteeMemberLoadSuccessAction,

    ICommitteeMemberSaveAction,
    ICommitteeMemberSaveSuccessAction,
    ICommitteeMemberSaveFailureAction,

    ICommitteeMemberCreateAction,
    ICommitteeMemberCreateSuccessAction,
    ICommitteeMemberCreateFailureAction,

    ICommitteeMemberValidateAction,
    ICommitteeMemberValidateSuccessAction,
    ICommitteeMemberValidateFailureAction,

    LoadSuccess,
    LoadFailure,


    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/committeeMember";
import { committeeMembersApi } from "../services/committeeMembers";


export const
    getCommitteeMembersEpic = (action$): Observable<ICommitteeMemberLoadSuccessAction | ICommitteeMemberLoadFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEMBER_LOAD)
            .mergeMap((action: ICommitteeMemberLoadAction) => {
                return committeeMembersApi
                    .getCommitteeMembers(action.committeeId)
                    .map(response =>
                        LoadSuccess(response.committeeMembers, undefined, [], response.lookups, undefined)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getCommitteeMembersByIdEpic = (action$): Observable<ICommitteeMemberLoadSuccessAction | ICommitteeMemberLoadFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEMBER_LOAD_BY_ID)
            .mergeMap((action: ICommitteeMemberLoadByIdAction) => {
                return committeeMembersApi
                    .getCommitteeMemberById(action.id)
                    .map(response =>
                        LoadSuccess(response.committeeMember, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getCommitteeMembersByCommitteeIdEpic = (action$): Observable<ICommitteeMemberLoadSuccessAction | ICommitteeMemberLoadFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEMBER_LOAD_BY_COMMITTEE_ID)
            .mergeMap((action: ICommitteeMemberLoadByCommitteeIdAction) => {
                return committeeMembersApi
                    .getCommitteeMemberByCommitteeId(action.committeeId)
                    .map(response =>
                        LoadSuccess(response.committeeMember, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setCommitteeMemberEpic = (action$): Observable<ICommitteeMemberSaveSuccessAction | ICommitteeMemberSaveFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEMBER_SAVE)
            .mergeMap((action: ICommitteeMemberSaveAction) => {
                return committeeMembersApi
                    .setCommitteeMember(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.committeeMember, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createCommitteeMemberEpic = (action$): Observable<ICommitteeMemberCreateSuccessAction | ICommitteeMemberCreateFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEMBER_CREATE)
            .mergeMap((action: ICommitteeMemberCreateAction) => {
                return committeeMembersApi
                    .createCommitteeMember(action.committeeId)
                    .map(response =>
                        CreateSuccess(response.committeeMember, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateCommitteeMemberEpic = (action$): Observable<ICommitteeMemberValidateSuccessAction | ICommitteeMemberValidateFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEMBER_VALIDATE)
            .mergeMap((action: ICommitteeMemberValidateAction) => {
                return committeeMembersApi
                    .validateCommitteeMember(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.committeeMember, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }